// extracted by mini-css-extract-plugin
module.exports = {"canvasContainer":"style_canvasContainer__2h7zS","stage":"style_stage__1VqYe","imgStyle":"style_imgStyle__1pBqR","spinner":"style_spinner__2Ad18"};